/**
 * ResultadoTextoField — Textarea with max 2000 chars counter.
 *
 * Requirements: 3.2
 */

import { useTranslation } from "react-i18next";

import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface ResultadoTextoFieldProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function ResultadoTextoField({ value, onChange, error }: ResultadoTextoFieldProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-2">
      <Label htmlFor="valor_texto">{t("procesamiento.captura.valor_texto")}</Label>
      <Textarea
        id="valor_texto"
        placeholder={t("procesamiento.captura.valor_texto_placeholder")}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`min-h-[120px] ${error ? "border-destructive" : ""}`}
        maxLength={2000}
        autoFocus
      />
      <div className="flex items-center justify-between">
        {error && <p className="text-xs text-destructive">{error}</p>}
        <p className="text-xs text-muted-foreground ml-auto">{value.length}/2000</p>
      </div>
    </div>
  );
}
